import { useSettings } from "../context/SettingsContext";

// Fixed, full-viewport atmospheric background: drifting aurora blobs in the
// active section's theme colors + a faint light-ray image + grain texture.
export default function AmbientBackground({ theme }) {
  const { theme: mode } = useSettings();
  const t = theme || { a: "#D4AF37", b: "#5C8A6E", c: "#2E5A66" };

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-background" aria-hidden="true">
      {/* drifting color blobs */}
      <div
        className="blob-a absolute -top-1/4 -left-10 h-[60vh] w-[60vh] rounded-full blur-[90px]"
        style={{ background: t.a, opacity: mode === "dark" ? 0.28 : 0.22 }}
      />
      <div
        className="blob-b absolute top-1/3 -right-16 h-[65vh] w-[65vh] rounded-full blur-[100px]"
        style={{ background: t.b, opacity: mode === "dark" ? 0.24 : 0.18 }}
      />
      <div
        className="blob-c absolute -bottom-1/4 left-1/4 h-[55vh] w-[55vh] rounded-full blur-[110px]"
        style={{ background: t.c, opacity: mode === "dark" ? 0.3 : 0.16 }}
      />

      {/* atmospheric symbolic light — golden field at dusk, very subtle / out of focus */}
      <div
        className="absolute inset-0 bg-cover bg-center mix-blend-screen"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600)",
          opacity: mode === "dark" ? 0.16 : 0.1,
          filter: "blur(6px)",
        }}
      />

      {/* parchment texture (light mode warmth) */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1648717008621-ee7e6acfe270?crop=entropy&cs=srgb&fm=jpg&q=60&w=1400)",
          opacity: mode === "dark" ? 0.04 : 0.14,
          mixBlendMode: mode === "dark" ? "screen" : "multiply",
        }}
      />

      {/* vignette to focus center */}
      <div
        className="absolute inset-0"
        style={{
          background:
            mode === "dark"
              ? "radial-gradient(circle at 50% 40%, transparent 30%, hsl(222 18% 7% / 0.85) 100%)"
              : "radial-gradient(circle at 50% 40%, transparent 35%, hsl(45 38% 95% / 0.7) 100%)",
        }}
      />
    </div>
  );
}
